import { getProducts } from "../../../Admin/State/Product/Action";
import { privateAxios } from "../../../config/apiConfig";
import { findProductById } from "../../../User/State/Product/Action";
import { getAllProduct } from "../Product/Action";
import {
  CREATE_COLOR_FAILURE,
  CREATE_COLOR_REQUEST,
  DELETE_COLOR_REQUEST,
  DELETE_COLOR_FAILURE,
  UPDATE_COLOR_REQUEST,
  UPDATE_COLOR_FAILURE,
  CREATE_COLOR_SUCCESS,
  UPDATE_COLOR_SUCCESS,
  DELETE_COLOR_SUCCESS,
} from "./ActionType";
import { toast } from "react-toastify";

export const createColor = (colorData) => async (dispatch) => {
  dispatch({ type: CREATE_COLOR_REQUEST });
  try {
    const { data } = await privateAxios.post(`vendor/product_color`, colorData);
    if (data?.status === "SUCCESS") {
      dispatch(getAllProduct());
      dispatch(getProducts());
      toast.success(data?.response);
      dispatch({ type: CREATE_COLOR_SUCCESS, payload: data?.response });
    } else {
      toast.error(data?.response);
    }
  } catch (error) {
    if (error?.response?.data?.status === "FAIL") {
      toast.error(error?.response?.data?.response);
    }
    dispatch({ type: CREATE_COLOR_FAILURE, payload: error.message });
  }
};

export const updateColor = (id, colorId, productId) => async (dispatch) => {
  dispatch({ type: UPDATE_COLOR_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `vendor/product_color/${id}/color/${colorId}`
    );
    if (data.status === "SUCCESS") {
      dispatch(getAllProduct());
      dispatch(getProducts());
      dispatch(findProductById(productId))
      toast.success("color Updated Successfully");
      dispatch({ type: UPDATE_COLOR_SUCCESS, payload: data?.response });
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error?.response?.data?.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_COLOR_FAILURE, payload: error.message });
  }
};

export const deleteColor = (colorId) => async (dispatch) => {
  dispatch({ type: DELETE_COLOR_REQUEST });
  try {
    const { data } = await privateAxios.delete(`vendor/product_color/${colorId}`);
    if (data.status === "SUCCESS") {
      dispatch(getAllProduct());
      dispatch(getProducts());
      toast.success(data.response);
      dispatch({ type: DELETE_COLOR_SUCCESS, payload: data?.response });
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_COLOR_FAILURE, payload: error.message });
  }
};
